export type PushLiveBranch = {
  id: string;
  name: string;
  workflowId: string;
};

export type PushError = {
  message: string;
  details?: { code?: string };
};

type ServerResult =
  | { type: "success" }
  | { type: "error"; error: { message: string; details?: unknown } };

export function executePushLive({
  branch,
  mainBranchId,
  onAccept,
  onDismiss,
  submitPush,
  onPushed,
  onPushFailed,
}: {
  branch: PushLiveBranch | undefined;
  mainBranchId: string | undefined;
  onAccept?: () => void;
  onDismiss?: () => void;
  submitPush: (
    sourceBranchId: string,
    message: string
  ) => { server: Promise<ServerResult> };
  onPushed: (branch: PushLiveBranch, mainBranchId: string | undefined) => void;
  onPushFailed: (branch: PushLiveBranch, error: PushError) => void;
}): Promise<boolean> | undefined {
  if (!branch || branch.name === "main") {
    onDismiss?.();
    return;
  }
  onAccept?.();
  const { server } = submitPush(branch.id, `Pushed from ${branch.name}`);
  onPushed(branch, mainBranchId);
  return server.then((r) => {
    if (r.type === "error") {
      const details = r.error.details as { code?: string } | null | undefined;
      onPushFailed(branch, {
        message: r.error.message,
        details: details ?? undefined,
      });
      return false;
    }
    return true;
  });
}
